import moment from 'moment-timezone'
import { IStop } from 'apps/fleet-planner/types'
import FORMATS from 'constants/datetime'

const START_AT_INCREMENT = 2
const END_AT_INCREMENT = 12
const END_OF_DAY_DEFAULT_TIME = '23:30'

export const getCutOffTime = (startAt: string) => {
  return moment.tz(startAt, FORMATS.defaultTimeZone).clone().hour(16).minute(0).second(0)
}

// Get the middle time of startAt and endAt
export const calculateAppointmentRange = (
  startAt: string,
  endAt: string,
  timezone: string | undefined = moment.tz.guess()
) => {
  const hours = moment(endAt).diff(startAt, 'hours') / 2
  return moment.tz(startAt, timezone).add(hours, 'hour')
}

// Business logic for reloads pickupStartDate
// If original load drop off is before 4:00pm est time, set it for same day
// If original load drop off is after 4:00pm est time, set it for next day
export const getReloadsPickupStartDate = (
  startAt: string,
  endAt: string | undefined,
  timezone: string | undefined = moment.tz.guess()
) => {
  const cutOffTime = getCutOffTime(startAt)
  let appointmentTime
  if (endAt) {
    appointmentTime = calculateAppointmentRange(startAt, endAt, timezone)
  } else {
    appointmentTime = moment.tz(startAt, timezone)
  }
  return appointmentTime.isBefore(cutOffTime) ? appointmentTime : appointmentTime.add('1', 'day')
}

export const getReloadsStopData = (stops: IStop[]) => {
  const lastStop = stops[stops.length - 1] || stops[0]
  const { city, displayTimezone, endAt, startAt, stateCode } = lastStop || {}
  return {
    city,
    displayTimezone,
    endAt,
    startAt,
    stateCode,
  }
}

export const getPickupTimeRange = (startAt: string, timezone: string) => {
  const endOfStartAtDay = moment.tz(startAt, timezone).set('hour', 23).set('minute', 59)
  const pickupTimesStartAt = moment
    .tz(startAt, timezone)
    .add(START_AT_INCREMENT, 'hours')
    .format(FORMATS.militaryTimeFormat)
  const pickupTimesEndAtMoment = moment.tz(startAt, timezone).add(END_AT_INCREMENT, 'hours')
  const isAfterEndOfStartDay = pickupTimesEndAtMoment.isAfter(endOfStartAtDay)
  const pickupTimesEndAt = isAfterEndOfStartDay
    ? END_OF_DAY_DEFAULT_TIME
    : pickupTimesEndAtMoment.format(FORMATS.militaryTimeFormat)
  return { pickupTimesStartAt, pickupTimesEndAt }
}
